const state = {
   features: null, // array of features around active point
   point: null, // map point of interest
};

// getters
const getters = {
   mapActivePoint: (state)=>{
      return state.point
   },
   mapActivePointFeatures: (state)=>{
      return state.features
   }
};

// actions
const actions = {
   MAP_ACTIVE_POINT_SET:(context, {point})=>{
      return new Promise((resolve, reject)=>{
         if (!point) return resolve();
         context.commit('MAP_ACTIVE_POINT_SET', {point});
         resolve();
      });
   },
   MAP_ACTIVE_POINT_CLEAR:(context)=>{
      return new Promise((resolve, reject)=>{
         context.commit('MAP_ACTIVE_POINT_SET', {point:null});
         resolve();
      });
   },
   MAP_ACTIVE_POINT_FEATURES_SET:(context, {features})=>{
      return new Promise((resolve, reject)=>{
         if (!features) return resolve();
         context.commit('MAP_ACTIVE_POINT_FEATURES_SET', {features});
         resolve();
      });
   }
};

// mutations
const mutations = {
   MAP_ACTIVE_POINT_SET:(state, {point})=>{
      state.point = point;
   },
   MAP_ACTIVE_POINT_FEATURES_SET:(state, {features})=>{
      state.features = features;
   },
};

export default {
   state,
   getters,
   actions,
   mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/mapActivePoint.js